import React from "react";
import Monitors from "../../config/MonitorsConfig";
import "./CountyOverlay.css"

export class CountyOverlay extends React.Component {

    render() {
        return (
            <div className="map-img">
                <img src={"../../../assets/base_map.png"} alt="" />

                <svg
                    viewBox={`0 0 335 437`}
                    preserveAspectRatio="xMidYMid meet"
                    className="map-overlay"
                >
                    {
                        this.props.counties.map((county) => (
                        <polygon
                            key={county.name}
                            points={county.coords
                                .map(([x, y]) => `${x},${y}`)
                                .join(" ")}
                            fill={county.backgroundColor || "#E1E1E1"}
                            stroke="#9a9a9a"
                            strokeWidth="1"
                            strokeOpacity={.85}
                            shapeRendering="crispEdges"
                            onClick={() => {
                                const params = new URLSearchParams(window.location.search);
                                params.set("county", county.name);
                                window.location.href = `/view/details/?${params.toString().replaceAll('%2F','/')}`;
                            }}
                        >
                            <title>{county.displayName}</title>
                        </polygon>
                    ))}

                    {
                        Monitors.map((monitor) => (

                        <circle
                            cx={monitor.coords[0]}
                            cy={monitor.coords[1]}
                            r={3}
                            fill="#0070ff"
                            stroke="black"
                            strokeWidth="1"
                        />

                    ))}

                </svg>
            </div>
        );
    }
}